import { ImageRegistration } from 'sb-lib/types';
import axios from 'axios';

export const uploadSignedPost = (file: Blob, s3Data: any) => {
  const postData = new FormData();
  for (const key in s3Data.fields) {
    if (s3Data.fields[key]) {
      postData.append(key, s3Data.fields[key]);
    }
  }
  postData.append('file', file);

  return axios.post(s3Data.url, postData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadSignedMultipartPut = (file: Blob, signedUrl: string) => {
  return axios.put(signedUrl, file);
};

export const uploadSignedPostWithProgress = (
  file: Blob,
  s3Data: ImageRegistration['uploadUrl'],
  onProgress: (p: number) => void,
) => {
  return new Promise<{ status: number; body: string }>((resolve, reject) => {
    let lastProgress = 0;
    const handleProgress = (p: number) => {
      if (p === 1 || Date.now() - lastProgress > 100) {
        lastProgress = Date.now();
        onProgress(p);
      }
    };
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', e => handleProgress(e.loaded / e.total));
    xhr.addEventListener('load', () => {
      resolve({ status: xhr.status, body: xhr.responseText });
    });
    xhr.addEventListener('error', () => reject(new Error('File upload failed')));
    xhr.addEventListener('abort', () => reject(new Error('File upload aborted')));
    xhr.open('POST', s3Data.url, true);
    console.log('s3Data', s3Data);
    const formData = new FormData();
    Object.entries(s3Data.fields).forEach(([k, v]) => formData.append(k, v));
    formData.append('file', file);

    xhr.send(formData);
  });
};
